import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config";

const WorkorderReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    start_date: today,
    end_date: today,
    dept_id: "0",
    action_type: "Fetch",
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [filterText, setFilterText] = useState("");

  /* =====================================================
   * LOAD DEPARTMENTS
   * =====================================================
   */
  const loadDepartments = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/departments");
      setDepartments(res.data.data || res.data);
    } catch (error) {
      toast.error("Failed to load departments");
    }
  };

  useEffect(() => {
    loadDepartments();
  }, []);

  /* =====================================================
   * HANDLE INPUT
   * =====================================================
   */
  const handleSelectChange = (name, value) => {
    setFilters({ ...filters, [name]: value });
  };

  const handleInput = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  /* =====================================================
   * FETCH WORKORDER REPORT
   * =====================================================
   */






  const downloadCSV = () => {
  if (!records.length) {
    toast.error("No records to download");
    return;
  }

  const header = [
    "Workorder Number",
    "Asset Code",
    "Asset Name",
    "Department",
    "Location",
    "Work Title",
    "Work Start Date",
    "Work End Date",
    "Workorder Cost",
    "Asset Cost",
    "Supplier Name",
    "Manufacturer Name"
  ];

  const rows = records.map(row => [
    row.workorder_no,
    row.asset_code,
    row.asset_name,
    row.department,
    row.location,
    row.work_title,
    row.start_date,
    row.end_date,
    row.workorder_cost,
    row.asset_cost,
    row.supplier_name,
    row.manufacturer_name
  ]);

  let csvContent =
    "data:text/csv;charset=utf-8," +
    [header, ...rows].map(e => e.join(",")).join("\n");

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "Workorder_Report.csv");
  document.body.appendChild(link);
  link.click();
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.get(API_BASE_URL + "/workorder_report_list", {
        params: filters,
      });

      const formatted = res.data.data.map((row) => ({
        workorder_no: row[0],
        asset_code: row[1],
        asset_name: row[2],
        department: row[3],
        location: row[4],
        work_title: row[5],
        start_date: row[6],
        end_date: row[7],
        workorder_cost: row[8],
        asset_cost: row[9],
        supplier_name: row[10],
        manufacture_name: row[11],
      }));

      setRecords(formatted);

      toast.success("Workorder Report Loaded", {
        position: "bottom-right",
      });
    } catch {
      toast.error("Failed to load report", {
        position: "bottom-right",
      });
    }
  };

  /* =====================================================
   * DATATABLE COLUMNS
   * =====================================================
   */
  const columns = [
    { name: "Workorder Number", selector: (row) => row.workorder_no, sortable: true },
    { name: "Asset Code", selector: (row) => row.asset_code, sortable: true },
    { name: "Asset Name", selector: (row) => row.asset_name, sortable: true },
    { name: "Department", selector: (row) => row.department, sortable: true },
    { name: "Location", selector: (row) => row.location, sortable: true },
    { name: "Work Title", selector: (row) => row.work_title, sortable: true },
    { name: "Work Start Date", selector: (row) => row.start_date, sortable: true },
    { name: "Work End Date", selector: (row) => row.end_date, sortable: true },
    { name: "Workorder Cost", selector: (row) => row.workorder_cost, sortable: true },
    { name: "Asset Cost", selector: (row) => row.asset_cost, sortable: true },
    { name: "Supplier Name", selector: (row) => row.supplier_name, sortable: true },
    { name: "Manufacture Name", selector: (row) => row.manufacture_name, sortable: true },
  ];

  /* =====================================================
   * SEARCH FILTER
   * =====================================================
   */
  const filteredData = records.filter((item) =>
    `${item.workorder_no} ${item.asset_code} ${item.asset_name} ${item.department} ${item.location}`
      .toLowerCase()
      .includes(filterText.toLowerCase())
  );

  /* =====================================================
   * SELECT OPTIONS
   * =====================================================
   */

  const deptOptions = [
    { label: "All Department", value: "0" },
    ...departments.map((d) => ({
      label: d.department_name,
      value: d.department_id,
    })),
  ];

  return (
    <div className="container mt-4">
      <ToastContainer />

      {/* HEADER MENU */}
      <div className="mb-3 d-flex gap-2">
        <a href="/Assetreport" className="btn btn-outline-secondary btn-sm">
          Asset Report
        </a>

        <a href="/workorder" className="btn btn-info btn-sm">
          Workorder Report
        </a>

        <a href="/consolidated" className="btn btn-outline-secondary btn-sm">
          Workorder Consolidated Report
        </a>
      </div>

      {/* FILTER CARD */}
      <div className="card mb-4 shadow-sm">
        <div className="card-header">
          <h6 className="mb-0">Workorder Report Filter</h6>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">

              {/* From Date */}
              <div className="col-md-2">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="start_date"
                  value={filters.start_date}
                  onChange={handleInput}
                />
              </div>

              {/* To Date */}
              <div className="col-md-2">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="end_date"
                  value={filters.end_date}
                  onChange={handleInput}
                />
              </div>

              {/* Department */}
              <div className="col-md-3">
                <label>Department</label>
                <Select
                  options={deptOptions}
                  value={deptOptions.find((d) => d.value === filters.dept_id)}
                  onChange={(val) => handleSelectChange("dept_id", val.value)}
                />
              </div>

              {/* Action */}
              <div className="col-md-2">
                <label>Action</label>
                <select
                  className="form-control"
                  name="action_type"
                  value={filters.action_type}
                  onChange={handleInput}
                >
                  <option value="Fetch">Show</option>
                </select>
              </div>

              {/* Submit */}
              <div className="col-md-2 d-flex align-items-end">
                <button className="btn btn-primary w-100">Get</button>
              </div>

            </div>
          </form>
        </div>
      </div>

      {/* TABLE */}
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">

  <div className="d-flex gap-2">
    <button className="btn btn-outline-secondary btn-sm" onClick={downloadCSV}>
      CSV
    </button>
  </div>

  <input
    type="text"
    className="form-control form-control-sm"
    placeholder="Search..."
    style={{ width: "200px" }}
    value={filterText}
    onChange={(e) => setFilterText(e.target.value)}
  />
</div>


        <div className="card-body">
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            striped
            highlightOnHover
          />
        </div>
      </div>
    </div>
  );
};

export default WorkorderReport;
